import { ImageRequirementNote, ImageSpec } from '../imageSpecs';

export function ImageUploadField({
  label,
  value,
  onChange,
  spec,
}: {
  label: string;
  value: string;
  onChange: (value: string) => void;
  spec: ImageSpec;
}) {
  return (
    <div>
      <label className="block">
        <span className="mb-1 block text-sm font-medium text-slate-700 dark:text-slate-300">{label}</span>
        <div className="grid gap-2 sm:grid-cols-[1fr_auto]">
          <input
            value={value}
            placeholder="CDN URL after upload"
            onChange={(event) => onChange(event.target.value)}
            className="h-10 w-full rounded-lg border border-slate-300 bg-white px-3 text-sm text-slate-900 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-100"
          />
          <label className="inline-flex h-10 cursor-pointer items-center justify-center rounded-lg border border-slate-300 px-3 text-sm font-semibold text-slate-700 hover:bg-slate-50 dark:border-slate-700 dark:text-slate-200 dark:hover:bg-slate-800">
            Upload
            <input
              type="file"
              accept="image/png,image/jpeg,image/webp,image/svg+xml"
              className="sr-only"
              onChange={(event) => {
                const file = event.target.files?.[0];
                if (!file) return;
                onChange(`pending-upload://${file.name}`);
              }}
            />
          </label>
        </div>
      </label>
      <ImageRequirementNote spec={spec} />
      {value.startsWith('pending-upload://') && (
        <div className="mt-2 rounded-md border border-amber-200 bg-amber-50 px-3 py-2 text-xs text-amber-800 dark:border-amber-900 dark:bg-amber-950 dark:text-amber-200">
          Upload pipeline pending: selected file will be sent through the CDN resize service when ST-1745 is implemented.
        </div>
      )}
    </div>
  );
}
